import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';
import { Edge, VflowModule, Node, Connection } from 'ngx-vflow';

export type HandleType = 'source' | 'target';

@Component({
  selector: 'app-vflow-chart',
  templateUrl: './vflow-chart.component.html',
  styleUrls: ['./vflow-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [VflowModule]
})
export class VflowChartComponent implements OnInit, OnChanges {
  @Input() nodes: Node[] = [];
  @Input() edges: Edge[] = [];

  ngOnInit(): void {
  }

  ngOnChanges(): void {
  }
}
